import _ from "lodash";

import { getLocalStorageUserProfile } from "./localStorage";

export const getAuthUserProfile = () => {
  const userProfile = getLocalStorageUserProfile();
  return {
    id: _.get(userProfile, ["id"]),
    user_type: _.get(userProfile, ["user_type"]),
    category_customer_id: _.get(userProfile, ["category_customer_id"]),
    // userManageLocations: _.get(userProfile, ["userManageLocations"]),
    userManageLocationIdList: _.chain(userProfile)
      .get(["manage_location"])
      .thru((item) => {
        return _.map(item, (locationId) => _.toInteger(locationId));
      })
      .value(),
  };
};
